import { GlobalSearchItem } from './global-search.models';

/** Static platform page / settings index for empty-query + `p:` searches. */
export const GLOBAL_SEARCH_PAGES: GlobalSearchItem[] = [
  {
    id: 'page-global-search',
    type: 'page',
    title: 'Global Search',
    subtitle: 'Advanced search across reports and applicants',
    keywords: ['global', 'search', 'find', 'lookup'],
    route: { path: '/global-search' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/global-search' } }]
  },
  {
    id: 'page-home',
    type: 'page',
    title: 'Dashboard',
    subtitle: 'Home overview',
    keywords: ['home', 'dashboard', 'overview'],
    route: { path: '/home' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/home' } }]
  },
  {
    id: 'page-qa',
    type: 'page',
    title: 'Quality Assurance',
    subtitle: 'QA queue',
    keywords: ['qa', 'quality', 'assurance', 'review'],
    route: { path: '/qa' },
    actions: [{ id: 'navigate', label: 'Open QA', primary: true, payload: { path: '/qa' } }]
  },
  {
    id: 'page-qa-errors',
    type: 'page',
    title: 'Errored Reports',
    subtitle: 'Error Queue',
    keywords: ['error', 'errored', 'errors', 'queue'],
    route: { path: '/qa/errors' },
    actions: [{ id: 'navigate', label: 'Open Error Queue', primary: true, payload: { path: '/qa/errors' } }]
  },
  {
    id: 'page-qa-completed',
    type: 'page',
    title: 'Completed Reports',
    subtitle: 'Completed queue',
    keywords: ['completed', 'complete', 'reports', 'queue'],
    route: { path: '/qa/completed' },
    actions: [{ id: 'navigate', label: 'Open Completed Reports', primary: true, payload: { path: '/qa/completed' } }]
  },
  {
    id: 'page-subscribers',
    type: 'page',
    title: 'Subscribers',
    subtitle: 'Manage subscribers',
    keywords: ['subscribers', 'accounts', 'companies'],
    route: { path: '/subscribers/manage-subscriber' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/subscribers/manage-subscriber' } }]
  },
  {
    id: 'page-add-subscriber',
    type: 'page',
    title: 'Add Subscriber',
    subtitle: 'Create subscriber account',
    keywords: ['add subscriber', 'new subscriber'],
    route: { path: '/add-subscriber' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/add-subscriber' } }]
  },
  {
    id: 'page-vendor-orders',
    type: 'page',
    title: 'Vendor Orders',
    subtitle: 'Vendor / TazWorks queue',
    keywords: ['vendor', 'orders', 'tazworks'],
    route: { path: '/vendor-orders' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/vendor-orders' } }]
  },
  {
    id: 'page-report-management',
    type: 'page',
    title: 'Report Management',
    subtitle: 'Reports admin',
    keywords: ['report management', 'reports'],
    route: { path: '/report-management' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/report-management' } }]
  },
  {
    id: 'page-order-reports',
    type: 'page',
    title: 'Order Report',
    subtitle: 'Subscriber order reports',
    keywords: ['order report', 'order reports', 'screening order'],
    route: { path: '/subscriber-reports/order-reports' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/subscriber-reports/order-reports' } }]
  },
  {
    id: 'page-edit-screening',
    type: 'page',
    title: 'Edit Screening',
    subtitle: 'Screening criteria',
    keywords: ['screening', 'criteria', 'criminal'],
    route: { path: '/edit-screening' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/edit-screening' } }]
  },
  {
    id: 'page-edit-pricing',
    type: 'page',
    title: 'Edit Pricing',
    subtitle: 'Pricing criteria',
    keywords: ['pricing', 'price', 'criteria'],
    route: { path: '/edit-pricing' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/edit-pricing' } }]
  },
  {
    id: 'page-manage-payments',
    type: 'page',
    title: 'Manage Payments',
    subtitle: 'Payments & invoices',
    keywords: ['payments', 'wallet', 'billing', 'invoice'],
    route: { path: '/manage-payments/invoice' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/manage-payments/invoice' } }]
  },
  {
    id: 'page-invoice-list',
    type: 'page',
    title: 'Invoices',
    subtitle: 'Invoice list',
    keywords: ['invoice', 'invoices'],
    route: { path: '/invoice-list' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/invoice-list' } }]
  },
  {
    id: 'page-logs',
    type: 'page',
    title: 'Logs',
    subtitle: 'System logs',
    keywords: ['logs', 'audit'],
    route: { path: '/logs' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/logs' } }]
  },
  {
    id: 'page-eviction-data',
    type: 'page',
    title: 'Eviction Data',
    subtitle: 'Eviction records',
    keywords: ['eviction', 'evictions'],
    route: { path: '/eviction-data' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/eviction-data' } }]
  },
  {
    id: 'page-admin-settings',
    type: 'page',
    title: 'Admin Settings',
    subtitle: 'Platform settings',
    keywords: ['settings', 'admin settings', 'config'],
    route: { path: '/admin-settings' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/admin-settings' } }]
  },
  {
    id: 'page-api-monitor',
    type: 'page',
    title: 'API Monitor',
    subtitle: 'API activity',
    keywords: ['api', 'monitor'],
    route: { path: '/api-monitor' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/api-monitor' } }]
  },
  {
    id: 'page-alerts',
    type: 'page',
    title: 'Alerts & Announcements',
    subtitle: 'Alerts',
    keywords: ['alerts', 'announcements'],
    route: { path: '/alert-announcements' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/alert-announcements' } }]
  },
  {
    id: 'page-disclosure',
    type: 'page',
    title: 'Disclosure Management',
    subtitle: 'Disclosures',
    keywords: ['disclosure', 'disclosures'],
    route: { path: '/disclosureManagment' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/disclosureManagment' } }]
  },
  {
    id: 'page-users',
    type: 'page',
    title: 'Users',
    subtitle: 'Manage admin users',
    keywords: ['users', 'admin users'],
    route: { path: '/users/manageusers' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/users/manageusers' } }]
  },
  {
    id: 'page-sales-representative',
    type: 'page',
    title: 'Sales Representative List',
    subtitle: 'Representative list and commissions',
    keywords: ['sales', 'representative', 'reps', 'commission'],
    route: { path: '/users/salesrepresentative' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/users/salesrepresentative' } }]
  },
  {
    id: 'page-manage-properties',
    type: 'page',
    title: 'Manage Properties',
    subtitle: 'Subscriber properties',
    keywords: ['properties', 'property'],
    route: { path: '/manageProperties' },
    actions: [{ id: 'navigate', label: 'Open', primary: true, payload: { path: '/manageProperties' } }]
  }
];

export function filterGlobalSearchPages(q: string, limit = 8): GlobalSearchItem[] {
  const needle = (q || '').trim().toLowerCase().replace(/^p:\s*/i, '');
  if (!needle) {
    return GLOBAL_SEARCH_PAGES.slice(0, limit);
  }
  return GLOBAL_SEARCH_PAGES
    .map((page) => {
      const hay = [page.title, page.subtitle, ...(page.keywords || [])].join(' ').toLowerCase();
      let score = 0;
      if (hay === needle) {
        score = 1;
      } else if (hay.startsWith(needle) || page.title.toLowerCase().startsWith(needle)) {
        score = 0.85;
      } else if (hay.includes(needle)) {
        score = 0.65;
      }
      return { ...page, score };
    })
    .filter((p) => (p.score || 0) > 0)
    .sort((a, b) => (b.score || 0) - (a.score || 0))
    .slice(0, limit);
}
